import { render } from "./zuluguard.vue?vue&type=template&id=3684b780"
import script from "./zuluguard.vue?vue&type=script&lang=js"
export * from "./zuluguard.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__